import React from 'react';
import useSWR from 'swr';

import { useHandleSWR } from '~/libs/helpers'
import useGlobalState from '~/libs/context';

import TaxReturnImage from '~/public/official-docs/tax-return-reiwa-1.png';
import { LabelCell, ValueCell } from '../styles/StyledTaxReturn';
import { OfficialDocumentContainer } from './OfficialDocumentContainer';

const TaxReturn_1 = ({ isEnglish }) => {
	const { year } = useGlobalState(); 
	const { data: swrBalanceSheet } = useSWR(`/api/metrics/balanceSheet?year=${year}`);
  const { data: balanceSheet } = useHandleSWR(swrBalanceSheet, 
    { assets: [], liabilities: [], totals: [] }, true);
  // TODO: Maybe we should find a way to get the totals directly from balanceSheet to avoid two requests
  const { data: swrProfitLoss } = useSWR(`/api/metrics/profitLoss?year=${year}`);
  const { data: profitLoss } = useHandleSWR(swrProfitLoss, { totals: [] }, true);
  const force = isEnglish;
  
	return (
    <OfficialDocumentContainer image={TaxReturnImage}>

      {/* Top Section */}
      <LabelCell en={"Address"} coords={[9.7, 33.8]} width={3.9} height={3.9} force={force} />
      <LabelCell en={"Office address"} coords={[14.4, 33.8]} width={3.9} height={3.9} force={force} />
      <LabelCell en={"Occupation"} coords={[19.1, 33.8]} width={3.9} height={3.9} force={force} />
      <LabelCell en={"Business name"} coords={[19.1, 46.7]} width={3.1} height={3.9} force={force} />

      <LabelCell en={"Full name"} coords={[9.6, 58.8]} width={3.9} height={4} force={force} />
      <LabelCell en={"Phone number"} coords={[14.4, 58.8]} width={3.9} height={4} force={force} />
      <LabelCell en={<i>Kanyū dantaimei</i>} coords={[19.1, 58.8]} width={3.9} height={4} force={force} />

      <LabelCell en={"Home: "} coords={[14.4, 63.3]} width={3.9} height={1.8} force={force} />
      <LabelCell en={"Office: "} coords={[16.5, 63.3]} width={3.9} height={1.8} force={force} />

      {/* Left Column */}

      {/* 1 */}
      <LabelCell en={"Sales"} coords={[36.5, 4.7]} width={11.6} height={5.6} force={force} />
      <ValueCell value={1} coords={[38.05, 18.71]} width={15.74} height={2.6} />

      {/* 2 */}
      <LabelCell en={"Inventory (start)"} coords={[42.84, 6.15]} width={10.2} height={2.69} force={force} />
      <ValueCell value={2} coords={[42.84, 18.71]} width={15.74} height={2.6} />

      {/* 3 */}
      <LabelCell en={"Purchases"} coords={[45.88, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={3} coords={[46.01, 18.71]} width={15.74} height={2.6} />

      {/* 4 */}
      <LabelCell en={"Subtotal"} coords={[49.05, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={4} coords={[49.15, 18.71]} width={15.74} height={2.6} />

      {/* 5 */}
      <LabelCell en={"Inventory (end)"} coords={[52.22, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={5} coords={[52.32, 18.71]} width={15.74} height={2.6} />

      {/* 6 */}
      <LabelCell en={"Net purchase cost"} coords={[55.39, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={6} coords={[55.49, 18.71]} width={15.74} height={2.6} />

      {/* 7 */}
      <LabelCell en={"Operating income"} coords={[58.8, 4.7]} width={11.6} height={5.5} force={force} />
      <ValueCell value={7} coords={[60.25, 18.71]} width={15.74} height={2.6} />

      {/* 8 */}
      <LabelCell en={"Other taxes"} coords={[64.9, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={9} coords={[65, 18.71]} width={15.74} height={2.6} />

      {/* 9 */}
      <LabelCell en={"Packing / freight"} coords={[68.07, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={10} coords={[68.17, 18.71]} width={15.74} height={2.6} />

      {/* 10 */}
      <LabelCell en={"Utilities"} coords={[71.24, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={11} coords={[71.34, 18.71]} width={15.74} height={2.6} />

      {/* 11 */}
      <LabelCell en={"Travel"} coords={[74.41, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={12} coords={[74.51, 18.71]} width={15.74} height={2.6} />

      {/* 12 */}
      <LabelCell en={"Communication"} coords={[77.58, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={13} coords={[77.68, 18.71]} width={15.74} height={2.6} />

      {/* 13 */}
      <LabelCell en={"Advertising"} coords={[80.75, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={14} coords={[80.85, 18.71]} width={15.74} height={2.6} />

      {/* 14 */}
      <LabelCell en={"Entertainment"} coords={[83.92, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={15} coords={[84.02, 18.71]} width={15.74} height={2.6} />

      {/* 15 */}
      <LabelCell en={"Insurances"} coords={[87.09, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={16} coords={[87.19, 18.71]} width={15.74} height={2.6} />

      {/* 16 */}
      <LabelCell en={"Repairs / maintenance"} coords={[90.26, 6.15]} width={10.2} height={2.79} force={force} />
      <ValueCell value={17} coords={[90.36, 18.71]} width={15.74} height={2.6} />

      {/* Center Column */}

      {/* 17 */}
      <LabelCell en={"Office supplies"} coords={[36.5, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={17} coords={[36.5, 49.1]} width={15.74} height={2.6} />

      {/* 18 */}
      <LabelCell en={"Depreciation"} coords={[39.67, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={18} coords={[39.67, 49.1]} width={15.74} height={2.6} />

      {/* 19 */}
      <LabelCell en={"Welfare"} coords={[42.84, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={19} coords={[42.84, 49.1]} width={15.74} height={2.6} />

      {/* 20 */}
      <LabelCell en={"Wages / salaries"} coords={[46.01, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={20} coords={[46.01, 49.1]} width={15.74} height={2.6} />

      {/* 21 */}
      <LabelCell en={"External fees"} coords={[49.18, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={21} coords={[49.18, 49.1]} width={15.74} height={2.6} />

      {/* 22 */}
      <LabelCell en={"Interest / discount"} coords={[52.35, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={22} coords={[52.35, 49.1]} width={15.74} height={2.6} />

      {/* 23 */}
      <LabelCell en={"Rent"} coords={[55.52, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={23} coords={[55.52, 49.1]} width={15.74} height={2.6} />

      {/* 24 */}
      <LabelCell en={"Uncollectable / Loss on sales"} coords={[58.69, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={24} coords={[58.69, 49.1]} width={15.74} height={2.6} />

      {/* 25 */}
      <LabelCell en={""} coords={[61.86, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={25} coords={[61.86, 49.1]} width={15.74} height={2.6} />

      {/* 26 */}
      <LabelCell en={" "} coords={[65.03, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={26} coords={[65.03, 49.1]} width={15.74} height={2.6} />

      {/* 27 */}
      <LabelCell en={""} coords={[68.2, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={27} coords={[68.2, 49.1]} width={15.74} height={2.6} />

      {/* 28 */}
      <LabelCell en={""} coords={[71.37, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={28} coords={[71.37, 49.1]} width={15.74} height={2.6} />

      {/* 29 */}
      <LabelCell en={""} coords={[74.54, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={29} coords={[74.54, 49.1]} width={15.74} height={2.6} />

      {/* 30 */}
      <LabelCell en={""} coords={[77.71, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={30} coords={[77.71, 49.1]} width={15.74} height={2.6} />

      {/* 31 */}
      <LabelCell en={"Others"} coords={[80.88, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={31} coords={[80.88, 49.1]} width={15.74} height={2.6} />

      {/* 32 */}
      <LabelCell en={"Total"} coords={[84.05, 36.65]} width={9.96} height={2.6} force={force} />
      <ValueCell value={32} coords={[84.05, 49.1]} width={15.74} height={2.6} />

      {/* 33 */}
      <LabelCell en={"Subtotal"} coords={[87.4, 35.15]} width={11.4} height={5.4} force={force} />
      <ValueCell value={33} coords={[88.8, 49.1]} width={15.74} height={2.6} />

      {/* Right Column */}

      {/* 34 */}
      <LabelCell en={"Write-back of provision"} coords={[36.5, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={34} coords={[36.5, 79.48]} width={15.74} height={2.6} />

      {/* 35 */}
      <LabelCell en={""} coords={[39.67, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={35} coords={[39.67, 79.48]} width={15.74} height={2.6} />

      {/* 36 */}
      <LabelCell en={""} coords={[42.84, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={36} coords={[42.84, 79.48]} width={15.74} height={2.6} />

      {/* 37 */}
      <LabelCell en={"Total"} coords={[46.01, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={37} coords={[46.01, 79.48]} width={15.74} height={2.6} />

      {/* 38 */}
      <LabelCell en={"Wages of family employees"} coords={[49.18, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={38} coords={[49.18, 79.48]} width={15.74} height={2.6} />

      {/* 39 */}
      <LabelCell en={"Allocation to provision"} coords={[52.35, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={39} coords={[52.35, 79.48]} width={15.74} height={2.6} />
      
      {/* 40 */}
      <LabelCell en={""} coords={[55.52, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={40} coords={[55.52, 79.48]} width={15.74} height={2.6} />

      {/* 41 */}
      <LabelCell en={""} coords={[58.69, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={41} coords={[58.69, 79.48]} width={15.74} height={2.6} />

      {/* 42 */}
      <LabelCell en={"Total"} coords={[61.86, 68.6]} width={8.42} height={2.6} force={force} />
      <ValueCell value={42} coords={[61.86, 79.48]} width={15.74} height={2.6} />

      {/* 43 */}
      <LabelCell en={"Result before deduction"} coords={[65.03, 65.5]} width={11.55} height={2.6} force={force} />
      <ValueCell value={43} coords={[65.03, 79.48]} width={15.74} height={2.6} />

      {/* 44 */}
      <LabelCell en={"Blue tax return deduction"} coords={[68.2, 65.5]} width={11.55} height={2.6} force={force} />
      <ValueCell value={44} coords={[68.2, 79.48]} width={15.74} height={2.6} />

      {/* 45 */}
      <LabelCell en={"Net result"} coords={[71.37, 65.5]} width={11.55} height={5.7} force={force} />
      <ValueCell value={45} coords={[72.94, 79.48]} width={15.74} height={2.6} />



    </OfficialDocumentContainer>
	);

};

export default TaxReturn_1;